<template>
  <div class="xiazai-box" v-if="show" @click="show = false">
  	<div class="xiazai-box-model" @click.stop>
  		<div class="app-box-ewm">
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<canvas v-if="androidUrl" ref="androidCanvas"></canvas>
  					<div v-else class="app-box-ewm-item-empty">
  						<span>{{$t('all.weixiazai')}}</span>
  					</div>
  				</div>
  				<div class="app-box-ewm-item-des">{{$t('all.anzhuoxiazai')}}</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/anzhuo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">GET IN ON</span>
  						<span class="app-box-ewm-item-div-content-span1">{{$t('all.anzhuoxiazai')}}</span>
  					</div>
  				</div>
  			</div>
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<canvas v-if="iosUrl" ref="iosCanvas"></canvas>
  					<div v-else class="app-box-ewm-item-empty">
  						<span>{{$t('all.weixiazai')}}</span>
  					</div>
  				</div>
  				<div class="app-box-ewm-item-des">{{$t('all.pingguoxiazai')}}</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/pingguo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">Download on the</span>
  						<span class="app-box-ewm-item-div-content-span1">{{$t('all.pingguoxiazai')}}</span>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import { getAppDownloadConfig } from "@/api/user";
import QRCode from 'qrcode';
export default {
  data() {
    return {
	  show:false,
	  data:'',
	  androidUrl: '',
	  iosUrl: ''
    };
  },
  watch: {
	androidUrl(val) {
		if (val) {
			this.$nextTick(() => {
				this.generateAndroidQRCode()
			})
		}
	},
	iosUrl(val) {
		if (val) {
			this.$nextTick(() => {
				this.generateIosQRCode()
			})
		}
	}
  },
  methods: {
	showModel(data){
		this.show = true
		this.androidUrl = ''
		this.iosUrl = ''
		this.getAppDownloadConfig()
	},
	async getAppDownloadConfig(){
		try {
			const res = await getAppDownloadConfig()
			this.data = res.data
			this.resolveDownloadUrl()
			this.$nextTick(() => {
				if (this.androidUrl) this.generateAndroidQRCode()
				if (this.iosUrl) this.generateIosQRCode()
			})
		} catch (error) {
			console.error('获取下载配置失败:', error)
		}
	},
	resolveDownloadUrl() {
		if (!this.data) return
		const isInternational = this.isInternationalVersion()
		if (isInternational) {
			this.androidUrl = this.data.androidDownloadUrl || ''
			this.iosUrl = this.data.iosDownloadUrl || ''
		} else {
			this.androidUrl = this.data.androidUrl || ''
			this.iosUrl = this.data.iosUrl || ''
		}
	},
	isInternationalVersion() {
		const lang = localStorage.getItem('language') || 'tw'
		const internationalLangs = ['en', 'ja', 'ko']
		return internationalLangs.includes(lang)
	},
	async generateAndroidQRCode() {
		if (!this.$refs.androidCanvas) return
		try {
			await QRCode.toCanvas(this.$refs.androidCanvas, this.androidUrl, {
				width: 220,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff'
				}
			})
		} catch (error) {
			console.error('生成安卓二维码失败:', error)
		}
	},
	async generateIosQRCode() {
		if (!this.$refs.iosCanvas) return
		try {
			await QRCode.toCanvas(this.$refs.iosCanvas, this.iosUrl, {
				width: 220,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff'
				}
			})
		} catch (error) {
			console.error('生成iOS二维码失败:', error)
		}
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./xiazai.css";
</style>



// WEBPACK FOOTER //
// xiazai.vue?23a4c685